export default "__VITE_ASSET__CMnu$gS6__"